import { ref, readonly } from 'vue';

const SELECTED_COMPANY_KEY = 'selected_company_id';

// Module-level shared state — ใช้ร่วมกันทั้ง Toolbar + listing pages
const _selectedCompanyId = ref<string>(localStorage.getItem(SELECTED_COMPANY_KEY) || '');

export function useSelectedCompany() {
    const setCompany = (id: string | null) => {
        _selectedCompanyId.value = id || '';
        if (_selectedCompanyId.value) {
            localStorage.setItem(SELECTED_COMPANY_KEY, _selectedCompanyId.value);
            return;
        }
        localStorage.removeItem(SELECTED_COMPANY_KEY);
    };

    return {
        selectedCompanyId: _selectedCompanyId,
        selectedCompanyIdReadonly: readonly(_selectedCompanyId),
        setCompany,
    };
}
